import React, { useEffect } from 'react';

const FrameBreaker = () => {
  useEffect(() => {
//test
    // Check if the page is being displayed in an iframe
    if (window.top !== window.self) {
      // If so, break out of the iframe by redirecting the parent window
      window.top.location = window.self.location;
    }
  }, []);

  return (
    <div>
    </div>
  );
};

export default FrameBreaker;
